import { Link } from "react-router-dom";
import { MessageCircle, Instagram, Mail } from "lucide-react";

const WHATSAPP_NUMBER = "919789715227";
const WHATSAPP_MSG = encodeURIComponent("Hello, I'd like to plan a journey with Travelorza");

export default function Footer({ onPlanJourney }) {
  return (
    <footer data-testid="footer" className="bg-black border-t border-white/5 py-16 md:py-20 px-6 md:px-12">
      <div className="max-w-7xl mx-auto">
        {/* Top row */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16">
          <div>
            <div className="mb-4">
              <p className="font-heading text-xl font-light text-white tracking-wide leading-snug">
                Travelorza Private Limited
              </p>
              <p className="text-[#71717A] text-xs tracking-wider mt-0.5">
                CIN: U79110TN2025PTC180563
              </p>
            </div>
            <address className="text-[#71717A] text-xs leading-relaxed not-italic mb-3">
              New No. 18/8, Old No. 20/8<br />
              Moors Road, Greams Road<br />
              Chennai 600006<br />
              Tamil Nadu, India
            </address>
            <p className="text-[#71717A] text-sm leading-relaxed max-w-xs">
              Experience beyond destinations. We design journeys that transform.
            </p>
          </div>

          <div>
            <p className="overline mb-5">Navigate</p>
            <div className="flex flex-col gap-3">
              {[
            { label: "Experiences", to: "/experiences" },
            { label: "Soulprint Quiz", to: "/quiz" },
            { label: "Services", to: "/services" },
            { label: "About", to: "/about" },
            { label: "EMI & Financing", to: "/emi" },
            { label: "Contact", to: "/contact" },
          ].map(l => (
                <Link
                  key={l.to}
                  to={l.to}
                  data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, '-')}`}
                  className="text-sm text-[#A1A1AA] hover:text-[#C9A84C] transition-colors tracking-wide"
                >
                  {l.label}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <p className="overline mb-5">Connect</p>
            <p className="text-[#71717A] text-sm mb-5 leading-relaxed">
              Your Experience Architect is one message away.
            </p>
            <a
              href={`https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MSG}`}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp-btn"
              className="inline-flex items-center gap-2 bg-[#25D366]/10 border border-[#25D366]/30 text-[#25D366] px-5 py-2.5 rounded-lg text-sm hover:bg-[#25D366]/20 transition-colors"
            >
              <MessageCircle size={16} />
              Chat on WhatsApp
            </a>
          </div>
        </div>

        {/* Bottom row */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 pt-6 border-t border-white/5">
          <div className="flex items-center gap-3">
            <img
              src="https://customer-assets.emergentagent.com/job_soulprint-travel/artifacts/pitf3ag2_Round%20Logo.svg"
              alt="Travelorza"
              className="w-8 h-8 object-contain"
              onError={e => { e.target.style.display = "none"; }}
            />
            <p className="text-[#71717A] text-xs tracking-wider">
              &copy; {new Date().getFullYear()} Travelorza. Travel isn&apos;t where you go. It&apos;s who you become.
            </p>
          </div>
          <div className="flex items-center gap-4">
            <Link to="/admin/login" data-testid="footer-admin-link" className="text-[#71717A] hover:text-[#C9A84C] text-xs tracking-wider transition-colors">
              Admin
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
